import { HeaderBar } from '@/components/NavBar/HeaderBar';
import logo from '@/assets/images/apilogy-logo.png';
import { Outlet, useNavigate } from 'react-router-dom';
import { Sidebar } from '@/components/Navigation/Sidebar';
import { useUserProfile } from '@/hooks/useUserProfile';
import { useEffect, useState } from 'react';
import { userStore } from '@/store/users';
import {
  axiosClient,
  getAccessToken,
  getRefreshToken,
} from '@/services/utilities';
import { frontConfig } from '@/config/front-config';
import LoadingOverlay from '@/components/LoadingOverlay';
import useLoadingStore from '@/store/loading';
import Cookies from 'js-cookie';

const config = frontConfig();

const navMenu = [
  {
    title: 'Logout',
    href: '/logout',
  },
];

export const UserLayout = () => {
  useUserProfile();
  const [userLogedIn] = userStore((state) => [
    state.userLogedIn,
    state.setUserLogedIn,
  ]);
  const accessToken = getAccessToken();
  const refreshToken = getRefreshToken();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const navigate = useNavigate();
  const { setLoading } = useLoadingStore();

  const logoutHandler = async () => {
    try {
      const { data } = await axiosClient.get(
        `${config.adminPortalBaseUrl}/auth/logout`,
      );
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('USERNAME');
      window.location = data;
    } catch (err) {
      alert('error logout')
    }
  };

  const handleMenuClick = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleCloseSidebar = () => {
    setIsSidebarOpen(false);
  };

  const handleToggleCollapse = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <article className="h-screen flex flex-col overflow-hidden">
      {/* Header */}
      <HeaderBar
        dropdownOption={navMenu}
        avatarUrl={userLogedIn?.info?.avatar}
        imageUrl={logo}
        onLogoutHandler={logoutHandler}
        onMenuClick={handleMenuClick}
        onToggleCollapse={handleToggleCollapse}
        username={userLogedIn?.username}
        userRole={userLogedIn?.isAdmin ? 'Admin' : ''}
      />
      
      {/* Main Layout with Sidebar */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={handleCloseSidebar}
          logoUrl={logo}
          isCollapsed={isSidebarCollapsed}
          onToggleCollapse={handleToggleCollapse}
        />

        {/* Main Content - with left margin to account for fixed sidebar */}
                {/* Main Content - with left margin to account for fixed sidebar */}
        <main className="flex-1 overflow-auto lg:ml-[300px] transition-all duration-300 pt-20">
          <section className="px-7 py-5">
            <Outlet />
          </section>
        </main>
      </div>
    </article>
  );
};